import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, Ref, reactive, computed, onBeforeMount } from 'vue'
import Order from "./order.vue"
import RosterList from "./rosterList.vue"

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const rosterRef=ref()
const refreshRoster=()=>{
    rosterRef.value.getRosterLists(true)
}

  
 

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(_component_el_tabs, { type: "border-card" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tab_pane, { label: "代付凭证" }, {
        default: _withCtx(() => [
          _createVNode(Order, { onRefreshRoster: refreshRoster })
        ]),
        _: 1
      }),
      _createVNode(_component_el_tab_pane, { label: "名单管理" }, {
        default: _withCtx(() => [
          _createVNode(RosterList, {
            ref_key: "rosterRef",
            ref: rosterRef
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})